import React, { useEffect, useState } from "react";
import ReportSearchSec from "./ReportSearchSec";
import Utils from "../../../../utils/Utils";
import WebUtils from "../../../../utils/WebUtils";
import ReportTable from "./ReportTable";
import {
  deleteResumeJdMatch,
  getAllResumeJdMatch,
} from "../../../../api/org-admin";
import { Pagination } from "antd";

function ReportMain({ setLoading }) {
  const userDetail = Utils.getUserDetail();
  const [reports, setReports] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("SORT_BY_CREATION_DATE_DESC");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [unAssignStudentFlag, setUnAssignStudentFlag] = useState(false);
  const [resumeState, setResumeState] = useState("ALL");
  const [deleteResumeTrigger, setDeleteResumeTrigger] = useState(0);

  const getAllReport = (currPage, pageSize, searchInput) => {
    const url = `${getAllResumeJdMatch}?userIdentifier=${userDetail?.userIdentifier}&sortBy=${sortBy}&pageNumber=${currPage}&pageSize=${pageSize}&searchInput=${searchInput}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let data = result?.data?.data;
          setReports(data?.resumeList);
          setPageCount(data?.totalCount);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const deleteReportApi = (resumeId) => {
    const url = `${deleteResumeJdMatch}?userIdentifier=${userDetail?.userIdentifier}&matchAnalysisIdentifier=${
      resumeId || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "DELETE")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setDeleteResumeTrigger((prev) => prev + 1);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };

  const sortItems = [
    {
      key: "SORT_BY_CREATION_DATE_ASC",
      label: "Creation Date (Old-New)",
    },
    {
      key: "SORT_BY_CREATION_DATE_DESC",
      label: "Creation Date (New-Old)",
    },
    {
      key: "SORT_BY_RESUME_FILE_NAME_ASC",
      label: "Resume Name (A-Z)",
    },
    {
      key: "SORT_BY_RESUME_FILE_NAME_DESC",
      label: "Resume Name (Z-A)",
    },
    {
      key: "SORT_BY_JOB_NAME_ASC",
      label: "Job Name (A-Z)",
    },
    {
      key: "SORT_BY_JOB_NAME_DESC",
      label: "Job Name (Z-A)",
    },
  ];

  useEffect(() => {
    getAllReport(currentPage, pageSize, searchValue);
  }, [pageSize, currentPage, sortBy, searchValue, deleteResumeTrigger]);

  return (
    <div className="mt-3">
      <ReportSearchSec
        setSortBy={setSortBy}
        sortBy={sortBy}
        searchText={searchText}
        sortItems={sortItems}
        searchText={searchText}
        setSearchText={setSearchText}
        reports={reports}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        selectedUserIds={selectedUserIds}
      />
      <ReportTable
        setSelectedUserIds={setSelectedUserIds}
        selectedUserIds={selectedUserIds}
        reports={reports}
        deleteReportApi={deleteReportApi}
      />
      <div className="flex justify-center mt-3 mb-1">
        <Pagination
          current={currentPage + 1}
          total={pageCount}
          pageSize={pageSize}
          onChange={onPageChange}
          showSizeChanger={true} // ✅ enable page size selector
          pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
        />
      </div>
    </div>
  );
}

export default ReportMain;
